/**
 * Slim catalog of quiz packs · metadata only (no questions array).
 * Imported eagerly by `useAchievements` (mounted in Router) so the full
 * quiz question content (~36 KB raw) stays out of the initial bundle and
 * can ride only with the future MiniQuiz screen chunk.
 *
 * Keep in sync with `quizPacks.ts` if a pack is added/removed.
 */

export interface QuizPackMeta {
  id: string;
  title: string;
  emoji: string;
  durationMin: number;
  relatedSprint: number;
  unlockBadgeId: string;
  unlockLabel: string;
  prerequisitePackId?: string;
}

export const QUIZ_PACKS_META: ReadonlyArray<QuizPackMeta> = [
  {
    id: 'ml-q-s01-01',
    title: 'Кому идти с этим вопросом? · 6 ситуаций',
    emoji: '👥',
    durationMin: 7,
    relatedSprint: 1,
    unlockBadgeId: 'sprint-01-core',
    unlockLabel: 'Sprint 01 Mindset Core complete',
  },
  {
    id: 'ml-q-s01-02',
    title: 'Какая Scrum/Kanban activity? · 7 contexts',
    emoji: '🎯',
    durationMin: 6,
    relatedSprint: 1,
    unlockBadgeId: 'sprint-01-core',
    unlockLabel: 'Sprint 01 Mindset Core complete · ML-Q-S01-01 solved',
    prerequisitePackId: 'ml-q-s01-01',
  },
  {
    id: 'ml-q-s01-03',
    title: 'BUDDY-1 reproducibility · 5 scenarios',
    emoji: '🔁',
    durationMin: 5,
    relatedSprint: 1,
    unlockBadgeId: 'sprint-01-core',
    unlockLabel: 'Sprint 01 complete · ML-Q-S01-02 solved',
    prerequisitePackId: 'ml-q-s01-02',
  },
  {
    id: 'ml-q-s01-04',
    title: 'Waterfall vs Agile · 5 контекстов',
    emoji: '🌊',
    durationMin: 5,
    relatedSprint: 1,
    unlockBadgeId: 'sprint-01-core',
    unlockLabel: 'Sprint 01 complete · ML-Q-S01-03 solved',
    prerequisitePackId: 'ml-q-s01-03',
  },
  {
    id: 'ml-q-s02-01',
    title: 'MoSCoW backlog sort · 8 items',
    emoji: '📋',
    durationMin: 6,
    relatedSprint: 2,
    unlockBadgeId: 'sprint-02-core',
    unlockLabel: 'Sprint 02 Requirements Core complete',
  },
  {
    id: 'ml-q-s02-02',
    title: 'AC anti-pattern spot · 6 examples',
    emoji: '🚫',
    durationMin: 6,
    relatedSprint: 2,
    unlockBadgeId: 'sprint-02-core',
    unlockLabel: 'Sprint 02 Requirements Core complete · ML-Q-S02-01 solved',
    prerequisitePackId: 'ml-q-s02-01',
  },
  {
    id: 'ml-q-s03-01',
    title: 'F/NF classify · 8 tests · ISO 25010',
    emoji: '⚖️',
    durationMin: 7,
    relatedSprint: 3,
    unlockBadgeId: 'sprint-03-core',
    unlockLabel: 'Sprint 03 Test Types Core complete',
  },
  {
    id: 'ml-q-s03-02',
    title: 'Pick approach · Black/White/Gray · 5 contexts',
    emoji: '🎨',
    durationMin: 5,
    relatedSprint: 3,
    unlockBadgeId: 'sprint-03-core',
    unlockLabel: 'Sprint 03 Test Types Core complete · ML-Q-S03-01 solved',
    prerequisitePackId: 'ml-q-s03-01',
  },
  {
    id: 'ml-q-s04-01',
    title: 'S×P calibration · 6 bugs',
    emoji: '🎚️',
    durationMin: 6,
    relatedSprint: 4,
    unlockBadgeId: 'sprint-04-core',
    unlockLabel: 'Sprint 04 Test Documentation Core complete',
  },
  {
    id: 'ml-q-s05-01',
    title: 'Pick test technique · 6 features',
    emoji: '🛠️',
    durationMin: 6,
    relatedSprint: 5,
    unlockBadgeId: 'sprint-05-core',
    unlockLabel: 'Sprint 05 Test Design Core complete',
  },
];
